import { fetchApi } from '@/config/axiosSetting.ts';
import { WopListResponseType } from '@/common/types/ApiResponseTypes.type.ts';

const getAtFaultIdentifierOptionsQuery = (): Promise<WopListResponseType[]> => {
  return fetchApi({
    method: 'GET',
    url: '/selection_item/at_fault_identifier/wop_list/',
  });
};

export default getAtFaultIdentifierOptionsQuery;
